import { Box, CircularProgress, Typography } from "@mui/material";
import { Translation } from "src/app/i18n";
import { useStyles } from "./loading.style";

const Loading = () => {
  const { classes } = useStyles();
  return (
    <Box className={classes.loadingContainer}>
      <CircularProgress color="secondary" size={28} />
      <Typography className={classes.loadingText}>
        {Translation("common.loading")}
      </Typography>
    </Box>
  )
}

export default Loading;